import * as Types from '../../../generated/types';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type ImportTextureSetRevisionFragment = { __typename: 'TextureSetRevision', id: string, name?: string | null, width: number, height: number, createdAt: string, createdBy?: { __typename: 'User', firstName?: string | null, lastName?: string | null } | null, mapAssignments: Array<{ __typename: 'TextureSetRevisionMapAssignment', textureType: Types.TextureType, dataObject: { __typename: 'DataObject', id: string } }>, editsProcessingJob?: { __typename: 'Job', id: string, state: Types.JobState } | null };

export type ImportTextureSetSourceFragment = { __typename: 'TextureSet', id: string, legacyId: number, name?: string | null, textureSetRevisions: Array<{ __typename: 'TextureSetRevision', id: string, name?: string | null, width: number, height: number, createdAt: string, createdBy?: { __typename: 'User', firstName?: string | null, lastName?: string | null } | null, mapAssignments: Array<{ __typename: 'TextureSetRevisionMapAssignment', textureType: Types.TextureType, dataObject: { __typename: 'DataObject', id: string } }>, editsProcessingJob?: { __typename: 'Job', id: string, state: Types.JobState } | null }> };

export type ImportTextureSetDialogSourceQueryVariables = Types.Exact<{
  materialId: Types.Scalars['ID']['input'];
}>;


export type ImportTextureSetDialogSourceQuery = { __typename: 'Query', material: { __typename: 'Material', id: string, textureGroup?: { __typename: 'TextureGroup', id: string, textureSets: Array<{ __typename: 'TextureSet', id: string, legacyId: number, name?: string | null, textureSetRevisions: Array<{ __typename: 'TextureSetRevision', id: string, name?: string | null, width: number, height: number, createdAt: string, createdBy?: { __typename: 'User', firstName?: string | null, lastName?: string | null } | null, mapAssignments: Array<{ __typename: 'TextureSetRevisionMapAssignment', textureType: Types.TextureType, dataObject: { __typename: 'DataObject', id: string } }>, editsProcessingJob?: { __typename: 'Job', id: string, state: Types.JobState } | null }> }> } | null } };

export type ImportTextureSetMutationVariables = Types.Exact<{
  input: Types.MutationImportTextureSetInput;
}>;


export type ImportTextureSetMutation = { __typename: 'Mutation', importTextureSet: { __typename: 'TextureSet', id: string, textureGroup: { __typename: 'TextureGroup', id: string } } };

export const ImportTextureSetRevisionFragmentDoc = gql`
    fragment ImportTextureSetRevision on TextureSetRevision {
  id
  name
  width
  height
  createdAt
  createdBy {
    firstName
    lastName
  }
  mapAssignments {
    textureType
    dataObject {
      id
    }
  }
  editsProcessingJob {
    id
    state
  }
}
    `;
export const ImportTextureSetSourceFragmentDoc = gql`
    fragment ImportTextureSetSource on TextureSet {
  id
  legacyId
  name
  textureSetRevisions {
    ...ImportTextureSetRevision
  }
}
    `;
export const ImportTextureSetDialogSourceDocument = gql`
    query importTextureSetDialogSource($materialId: ID!) {
  material(id: $materialId) {
    id
    textureGroup {
      id
      textureSets {
        ...ImportTextureSetSource
      }
    }
  }
}
    ${ImportTextureSetSourceFragmentDoc}
${ImportTextureSetRevisionFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ImportTextureSetDialogSourceGQL extends Apollo.Query<ImportTextureSetDialogSourceQuery, ImportTextureSetDialogSourceQueryVariables> {
    override document = ImportTextureSetDialogSourceDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ImportTextureSetDocument = gql`
    mutation importTextureSet($input: MutationImportTextureSetInput!) {
  importTextureSet(input: $input) {
    id
    textureGroup {
      id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ImportTextureSetGQL extends Apollo.Mutation<ImportTextureSetMutation, ImportTextureSetMutationVariables> {
    override document = ImportTextureSetDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }